import { render, staticRenderFns } from "./query-notice.vue?vue&type=template&id=df1ba5ac&scoped=true"
import script from "./query-notice.vue?vue&type=script&lang=js"
export * from "./query-notice.vue?vue&type=script&lang=js"
import style0 from "./query-notice.vue?vue&type=style&index=0&id=df1ba5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1ba5ac",
  null
  
)

export default component.exports